import React, { useState } from "react";
import { useUser } from "../context/user";
import { update } from "../server/server";
import { useToasts } from "react-toast-notifications";
import "../styles/PersonalInfo.css";
import { useTranslation } from "react-i18next";

export default function PersonalInfo(props) {
    const { user, setUser } = useUser();
    const { addToast } = useToasts();
    const [name, setName] = useState(user.first_name);
    const [surname, setSurname] = useState(user.last_name || "");
    const [gender] = useState(user.gender);
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const _user = {
            ...user,
            first_name: name,
            last_name: surname,
            gender,
        };
        const resp = await update({ collection: "users", data: _user });

        if (resp.status === 200) {
            addToast("User is updated!", { appearance: "success", autoDismiss: true });
            setUser(_user);
        }
    };

    return (
        <>
            <div className="personal-info-container">
                <div className="notes-title">{t("personalInformation")}</div>

                <div className="profile-form">
                    <form onSubmit={handleSubmit}>
                        <fieldset>
                            <label htmlFor="name">
                                <p>{t("name")}</p>
                            </label>
                            <input
                                type="text"
                                name="first_name"
                                placeholder="Enter your first name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </fieldset>
                        <fieldset>
                            <label htmlFor="surname">
                                <p>{t("surname")}</p>
                            </label>
                            <input
                                type="text"
                                name="last_name"
                                placeholder="Enter your surname"
                                value={surname}
                                onChange={(e) => setSurname(e.target.value)}
                            />
                        </fieldset>

                        <button className="main-button">{t("save")}</button>
                    </form>
                </div>
            </div>
        </>
    );
}
